import * as React from 'react';
const ChevronLeftIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.214 15.597-5.396-5.096a.7.7 0 0 1-.158-.776.7.7 0 0 1 .157-.23l5.392-5.091v-.001a.699.699 0 0 1 .97 1.005l-4.872 4.59 4.873 4.59.003.003a.7.7 0 1 1-.969 1.006"
      fill="currentColor"
    />
  </svg>
);
export default ChevronLeftIcon;
